/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCommControlLookup.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-comm-control-lookup";

export class AutogenModelEdiCommControlLookup<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCommControlLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCommControlLookup extends ModelRow<RowEdiCommControlLookupFields> {
	constructor(values?: Partial<RowEdiCommControlLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCommControlLookupFields {
	access_token_url: string;
	app_type: string;
	as2_cert_exp_date: Date;
	as2_cert_file: string;
	as2_email: string;
	as2_encryption: string;
	as2_id: string;
	as2_inbox: string;
	as2_mdn_options: string;
	as2_mdn_required: string;
	as2_mdn_synch: string;
	as2_mdn_url: string;
	as2_partner: string;
	as2_partner_id: string;
	as2_signature: string;
	as2_url: string;
	as2_x509_alias: string;
	as2server_instance: string;
	auth_token: string;
	auth_type: string;
	base_encode_auth: string;
	client_authentication: string;
	client_id: string;
	client_secret: string;
	comm_contact_id: string;
	comm_status: string;
	comm_timeout: number;
	comm_type: string;
	command_line: string;
	company_id: string;
	conn_method: string;
	conn_mode: string;
	conn_type: string;
	connection_string: string;
	default_loc_dir: string;
	delete_local_file: string;
	delete_remote_file: string;
	direction: string;
	directory_local: string;
	directory_remote: string;
	ediprofile_key: string;
	expires_in: number;
	file_rename: string;
	gpg_home: string;
	grafter_filename: string;
	grant_type: string;
	header_prefix: string;
	http_param_template_id: number;
	http_request_type: string;
	id: number;
	img_del_rem: string;
	img_loc_dir: string;
	img_loc_rename: string;
	img_remote_dir: string;
	img_use_def_dir: string;
	ip_host: string;
	ip_server: string;
	is_fms_comm: string;
	is_pooled_comm: string;
	is_production: string;
	key_name: string;
	key_password: string;
	name: string;
	new_docs_only: string;
	notes: string;
	omit_extra_line: string;
	outage_end: Date;
	outage_start: Date;
	overwrite_ext: string;
	port: number;
	priority: number;
	proxy_server: string;
	queue_name: string;
	remote_filename: string;
	remote_password: string;
	remote_user: string;
	repository_dir: string;
	req_header_prefix: string;
	request_body_format: string;
	scope: string;
	send_success_email: string;
	server_name: string;
	ssh_key_file: string;
	ssh_key_pwd: string;
	ssh_version: string;
	sub_type: string;
	success_response: string;
	token_key: string;
}

